/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const CLIENT_FETCH_REQUEST = 'CLIENT_FETCH_REQUEST';
export const CLIENT_FETCH_REQUEST_SUCCESS = 'CLIENT_FETCH_REQUEST_SUCCESS';
export const CLIENT_FETCH_REQUEST_FAILURE = 'CLIENT_FETCH_REQUEST_FAILURE';

export const SINGLE_ASSOCIATION_FETCH_REQUEST = 'SINGLE_ASSOCIATION_FETCH_REQUEST';
export const SINGLE_ASSOCIATION_FETCH_REQUEST_SUCCESS = 'SINGLE_ASSOCIATION_FETCH_REQUEST_SUCCESS';
export const SINGLE_ASSOCIATION_FETCH_REQUEST_FAILURE = 'SINGLE_ASSOCIATION_FETCH_REQUEST_FAILURE';

export const CLIENT_UPSERT_REQUEST = 'CLIENT_UPSERT_REQUEST';
export const CLIENT_UPSERT_REQUEST_SUCCESS = 'CLIENT_UPSERT_REQUEST_SUCCESS';
export const CLIENT_UPSERT_REQUEST_FAILURE = 'CLIENT_UPSERT_REQUEST_FAILURE';

export const CLIENT_DELETE_REQUEST = 'CLIENT_DELETE_REQUEST';
export const CLIENT_DELETE_REQUEST_SUCCESS = 'CLIENT_DELETE_REQUEST_SUCCESS';
export const CLIENT_DELETE_REQUEST_FAILURE = 'CLIENT_DELETE_REQUEST_FAILURE';

export const ASSOCIATION_UPSERT_REQUEST = 'ASSOCIATION_UPSERT_REQUEST';
export const ASSOCIATION_UPSERT_REQUEST_SUCCESS = 'ASSOCIATION_UPSERT_REQUEST_SUCCESS';
export const ASSOCIATION_UPSERT_REQUEST_FAILURE = 'ASSOCIATION_UPSERT_REQUEST_FAILURE';

export const CLIENT_TIMEZONE_FETCH_REQUEST = 'CLIENT_TIMEZONE_FETCH_REQUEST';
export const CLIENT_TIMEZONE_FETCH_REQUEST_SUCCESS = 'CLIENT_TIMEZONE_FETCH_REQUEST_SUCCESS';
export const CLIENT_TIMEZONE_FETCH_REQUEST_FAILURE = 'CLIENT_TIMEZONE_FETCH_REQUEST_FAILURE';

export const CLIENT_STATE_FETCH_REQUEST = 'CLIENT_STATE_FETCH_REQUEST';
export const CLIENT_STATE_FETCH_REQUEST_SUCCESS = 'CLIENT_STATE_FETCH_REQUEST_SUCCESS';
export const CLIENT_STATE_FETCH_REQUEST_FAILURE = 'CLIENT_STATE_FETCH_REQUEST_FAILURE';

export const CLIENT_CATEGORY_FETCH_REQUEST = 'CLIENT_CATEGORY_FETCH_REQUEST';
export const CLIENT_CATEGORY_FETCH_REQUEST_SUCCESS = 'CLIENT_CATEGORY_FETCH_REQUEST_SUCCESS';
export const CLIENT_CATEGORY_FETCH_REQUEST_FAILURE = 'CLIENT_CATEGORY_FETCH_REQUEST_FAILURE';

export const SINGLE_CLIENT_UPDATE_REQUEST = 'SINGLE_CLIENT_UPDATE_REQUEST';
export const SINGLE_CLIENT_UPDATE_REQUEST_SUCCESS = 'SINGLE_CLIENT_UPDATE_REQUEST_SUCCESS';
export const SINGLE_CLIENT_UPDATE_REQUEST_FAILURE = 'SINGLE_CLIENT_UPDATE_REQUEST_FAILURE';

export const SINGLE_CLIENT_FETCH_REQUEST = 'SINGLE_CLIENT_FETCH_REQUEST';
export const SINGLE_CLIENT_FETCH_REQUEST_SUCCESS = 'SINGLE_CLIENT_FETCH_REQUEST_SUCCESS';
export const SINGLE_CLIENT_FETCH_REQUEST_FAILURE = 'SINGLE_CLIENT_FETCH_REQUEST_FAILURE';

export const MERGE_CLIENT_DETAIL_FETCH_REQUEST = 'MERGE_CLIENT_DETAIL_FETCH_REQUEST';
export const MERGE_CLIENT_DETAIL_FETCH_REQUEST_SUCCESS =
  'MERGE_CLIENT_DETAIL_FETCH_REQUEST_SUCCESS';
export const MERGE_CLIENT_DETAIL_FETCH_REQUEST_FAILURE =
  'MERGE_CLIENT_DETAIL_FETCH_REQUEST_FAILURE';
export const MERGE_CLIENT_DETAIL_CLEAN_REQUEST = 'MERGE_CLIENT_DETAIL_CLEAN_REQUEST';

export const CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST = 'CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST';
export const CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_SUCCESS =
  'CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_SUCCESS';
export const CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_FAILURE =
  'CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_FAILURE';
export const CLEAN_CLIENT_FILING_STATUS_YEAR_PROPS = 'CLEAN_CLIENT_FILING_STATUS_YEAR_PROPS';

export const DOCUMENT_SIGNER_FLIP_REQUEST = 'DOCUMENT_SIGNER_FLIP_REQUEST';
export const DOCUMENT_SIGNER_FLIP_REQUEST_SUCCESS = 'DOCUMENT_SIGNER_FLIP_REQUEST_SUCCESS';
export const DOCUMENT_SIGNER_FLIP_REQUEST_FAILURE = 'DOCUMENT_SIGNER_FLIP_REQUEST_FAILURE';

export const CLIENT_UPLOAD_REQUEST = 'CLIENT_UPLOAD_REQUEST';
export const CLIENT_UPLOAD_REQUEST_SUCCESS = 'CLIENT_UPLOAD_REQUEST_SUCCESS';
export const CLIENT_UPLOAD_REQUEST_FAILURE = 'CLIENT_UPLOAD_REQUEST_FAILURE';

export const CLIENT_REGISTER_REQUEST = 'CLIENT_REGISTER_REQUEST';
export const CLIENT_REGISTER_REQUEST_SUCCESS = 'CLIENT_REGISTER_REQUEST_SUCCESS';
export const CLIENT_REGISTER_REQUEST_FAILURE = 'CLIENT_REGISTER_REQUEST_FAILURE';

export const CLIENT_ASSOCIATION_FETCH_REQUEST = 'CLIENT_ASSOCIATION_FETCH_REQUEST';
export const CLIENT_ASSOCIATION_FETCH_REQUEST_SUCCESS = 'CLIENT_ASSOCIATION_FETCH_REQUEST_SUCCESS';
export const CLIENT_ASSOCIATION_FETCH_REQUEST_FAILURE = 'CLIENT_ASSOCIATION_FETCH_REQUEST_FAILURE';

export const CLIENT_ASSOCIATION_ADD_REQUEST = 'CLIENT_ASSOCIATION_ADD_REQUEST';
export const CLIENT_ASSOCIATION_ADD_REQUEST_SUCCESS = 'CLIENT_ASSOCIATION_ADD_REQUEST_SUCCESS';
export const CLIENT_ASSOCIATION_ADD_REQUEST_FAILURE = 'CLIENT_ASSOCIATION_ADD_REQUEST_FAILURE';

export const CLIENT_CLEAN_REQUEST = 'CLIENT_CLEAN_REQUEST';
export const SINGLE_CLIENT_CLEAN_REQUEST = 'SINGLE_CLIENT_CLEAN_REQUEST';
export const CLIENT_ASSOCIATION_CLEAN_REQUEST = 'CLIENT_ASSOCIATION_CLEAN_REQUEST';
export const CLIENT_ASSOCIATION_SINGLE_CLEAN_REQUEST = 'CLIENT_ASSOCIATION_SINGLE_CLEAN_REQUEST';
export const CLIENT_DELETE_ERROR_CLEAN_REQUEST = 'CLIENT_DELETE_ERROR_CLEAN_REQUEST';

export const CLIENT_FILING_STATUS_FETCH_REQUEST = 'CLIENT_FILING_STATUS_FETCH_REQUEST';
export const CLIENT_FILING_STATUS_FETCH_REQUEST_SUCCESS =
  'CLIENT_FILING_STATUS_FETCH_REQUEST_SUCCESS';
export const CLIENT_FILING_STATUS_FETCH_REQUEST_FAILURE =
  'CLIENT_FILING_STATUS_FETCH_REQUEST_FAILURE';

export const CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST = 'CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST';
export const CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_SUCCESS =
  'CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_SUCCESS';
export const CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_FAILURE =
  'CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_FAILURE';

export const CLIENT_FORGET_PASSWORD_FETCH_REQUEST = 'CLIENT_FORGET_PASSWORD_FETCH_REQUEST';
export const CLIENT_FORGET_PASSWORD_FETCH_REQUEST_SUCCESS =
  'CLIENT_FORGET_PASSWORD_FETCH_REQUEST_SUCCESS';
export const CLIENT_FORGET_PASSWORD_FETCH_REQUEST_FAILURE =
  'CLIENT_FORGET_PASSWORD_FETCH_REQUEST_FAILURE';

export const CLIENT_DROPDOWN_FETCH_REQUEST = 'CLIENT_DROPDOWN_FETCH_REQUEST';
export const CLIENT_DROPDOWN_FETCH_REQUEST_SUCCESS = 'CLIENT_DROPDOWN_FETCH_REQUEST_SUCCESS';
export const CLIENT_DROPDOWN_FETCH_REQUEST_FAILURE = 'CLIENT_DROPDOWN_FETCH_REQUEST_FAILURE';

export const CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST =
  'CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST';
export const CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS =
  'CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS';
export const CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE =
  'CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE';

export const CLIENT_SSN_FETCH_REQUEST = 'CLIENT_SSN_FETCH_REQUEST';
export const CLIENT_SSN_FETCH_REQUEST_SUCCESS = 'CLIENT_SSN_FETCH_REQUEST_SUCCESS';
export const CLIENT_SSN_FETCH_REQUEST_FAILURE = 'CLIENT_SSN_FETCH_REQUEST_FAILURE';

export const UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST = 'UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST';
export const UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_SUCCESS =
  'UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_SUCCESS';
export const UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_FAILURE =
  'UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_FAILURE';

export const LINK_ACCOUNT_REQUEST = 'LINK_ACCOUNT_REQUEST';
export const LINK_ACCOUNT_REQUEST_SUCCESS = 'LINK_ACCOUNT_REQUEST_SUCCESS';
export const LINK_ACCOUNT_REQUEST_FAILURE = 'LINK_ACCOUNT_REQUEST_FAILURE';

export const CLEAN_LINK_PROPS = 'CLEAN_LINK_PROPS';

export const ONBOARDING_CLIENT_DELETE_REQUEST = 'ONBOARDING_CLIENT_DELETE_REQUEST';
export const ONBOARDING_CLIENT_DELETE_REQUEST_SUCCESS = 'ONBOARDING_CLIENT_DELETE_REQUEST_SUCCESS';
export const ONBOARDING_CLIENT_DELETE_REQUEST_FAILURE = 'ONBOARDING_CLIENT_DELETE_REQUEST_FAILURE';

export const ONBOARDING_CLIENT_CLEAN_REQUEST = 'ONBOARDING_CLIENT_CLEAN_REQUEST';

export const REQUEST_FOR_CLIENT_DELETE = 'REQUEST_FOR_CLIENT_DELETE';
export const REQUEST_FOR_CLIENT_DELETE_SUCCESS = 'REQUEST_FOR_CLIENT_DELETE_SUCCESS';
export const REQUEST_FOR_CLIENT_DELETE_FAILURE = 'REQUEST_FOR_CLIENT_DELETE_FAILURE';

export const CONFIRM_CLIENT_DELETE_REQUEST = 'CONFIRM_CLIENT_DELETE_REQUEST';
export const CONFIRM_CLIENT_DELETE_REQUEST_SUCCESS = 'CONFIRM_CLIENT_DELETE_REQUEST_SUCCESS';
export const CONFIRM_CLIENT_DELETE_REQUEST_FAILURE = 'CONFIRM_CLIENT_DELETE_REQUEST_FAILURE';

export const CLEAN_CLIENT_DELETE_PROPS = 'CLEAN_CLIENT_DELETE_PROPS';
export const ASSOCIATION_SHARE_REQUEST = 'ASSOCIATION_SHARE_REQUEST';
export const ASSOCIATION_SHARE_REQUEST_SUCCESS = 'ASSOCIATION_SHARE_REQUEST_SUCCESS';
export const ASSOCIATION_SHARE_REQUEST_FAILURE = 'ASSOCIATION_SHARE_REQUEST_FAILURE';

export const ASSOCIATION_SUMMARY_FETCH_REQUEST = 'ASSOCIATION_SUMMARY_FETCH_REQUEST';
export const ASSOCIATION_SUMMARY_FETCH_REQUEST_SUCCESS =
  'ASSOCIATION_SUMMARY_FETCH_REQUEST_SUCCESS';
export const ASSOCIATION_SUMMARY_FETCH_REQUEST_FAILURE =
  'ASSOCIATION_SUMMARY_FETCH_REQUEST_FAILURE';

export const CLEAN_ASSOCIATION_SUMMARY = 'CLEAN_ASSOCIATION_SUMMARY';

export const CLEAN_TAX_FILING_STATUS = 'CLEAN_TAX_FILING_STATUS';

export const FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST =
  'FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST';
export const FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_SUCCESS =
  'FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_SUCCESS';
export const FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_FAILURE =
  'FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_FAILURE';

export const UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST = 'UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST';
export const UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_SUCCESS =
  'UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_SUCCESS';
export const UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_FAILURE =
  'UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_FAILURE';

export const CLEAN_TAXREPRESENTATIVE_CHANGE_STATUS = 'CLEAN_TAXREPRESENTATIVE_CHANGE_STATUS';

export const FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST =
  'FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST';
export const FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_SUCCESS =
  'FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_SUCCESS';
export const FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_FAILURE =
  'FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_FAILURE';

export const FETCH_CLIENT_ACTIVITY_LOG_REQUEST = 'FETCH_CLIENT_ACTIVITY_LOG_REQUEST';
export const FETCH_CLIENT_ACTIVITY_LOG_REQUEST_SUCCESS =
  'FETCH_CLIENT_ACTIVITY_LOG_REQUEST_SUCCESS';
export const FETCH_CLIENT_ACTIVITY_LOG_REQUEST_FAILURE =
  'FETCH_CLIENT_ACTIVITY_LOG_REQUEST_FAILURE';

export const CLEAN_CLIENT_ERROR_PROPS = 'CLEAN_CLIENT_ERROR_PROPS';

export const DELETE_CLIENT_PROPS_CLEAN = 'DELETE_CLIENT_PROPS_CLEAN';

export const CHECK_VALID_SSN_REQUEST = 'CHECK_VALID_SSN_REQUEST';
export const CHECK_VALID_SSN_REQUEST_SUCCESS = 'CHECK_VALID_SSN_REQUEST_SUCCESS';
export const CHECK_VALID_SSN_REQUEST_FAILURE = 'CHECK_VALID_SSN_REQUEST_FAILURE';

export const CLEAN_SSN_VALIDATION = 'CLEAN_SSN_VALIDATION';

export const CHECK_VALID_EMAIL_REQUEST = 'CHECK_VALID_EMAIL_REQUEST';
export const CHECK_VALID_EMAIL_REQUEST_SUCCESS = 'CHECK_VALID_EMAIL_REQUEST_SUCCESS';
export const CHECK_VALID_EMAIL_REQUEST_FAILURE = 'CHECK_VALID_EMAIL_REQUEST_FAILURE';

export const CLEAN_EMAIL_REQUEST = 'CLEAN_EMAIL_REQUEST';

export const CLIENT_FIELD_TEMPLATE_FETCH_REQUEST = 'CLIENT_FIELD_TEMPLATE_FETCH_REQUEST';
export const CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS =
  'CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS';
export const CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_FAILURE =
  'CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_FAILURE';

export const CLIENT_ALL_LIST_FETCH_REQUEST = 'CLIENT_ALL_LIST_FETCH_REQUEST';
export const CLIENT_ALL_LIST_FETCH_REQUEST_SUCCESS = 'CLIENT_ALL_LIST_FETCH_REQUEST_SUCCESS';
export const CLIENT_ALL_LIST_FETCH_REQUEST_FAILURE = 'CLIENT_ALL_LIST_FETCH_REQUEST_FAILURE';
